import { render, staticRenderFns } from "./hist-impexp-graph-tm-total-mp1c.vue?vue&type=template&id=2fa5528a&"
import script from "./hist-impexp-graph-tm-total-mp1c.vue?vue&type=script&lang=js&"
export * from "./hist-impexp-graph-tm-total-mp1c.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("/home/application/eu/trade-dsm-frontend_2022/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fa5528a')) {
      api.createRecord('2fa5528a', component.options)
    } else {
      api.reload('2fa5528a', component.options)
    }
    module.hot.accept("./hist-impexp-graph-tm-total-mp1c.vue?vue&type=template&id=2fa5528a&", function () {
      api.rerender('2fa5528a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trade-dsm-application/graphs/mp1c/hist-impexp-graph-tm-total-mp1c.vue"
export default component.exports